export const flattenArray = array => array.reduce((a, b) => a.concat(b), [])